import type { IEnglishIqResultV2 } from '@repo/sdk';
import { Ear, Languages, TextCursorInput } from 'lucide-react';
import type { EnglishIqMessagesType } from '../../english-iq-messages-type';

interface IEnglishIqV2EvidenceProps {
  evidence: IEnglishIqResultV2['evidence'];
  messages: EnglishIqMessagesType['v2']['result'];
}

export function EnglishIqV2Evidence({
  evidence,
  messages,
}: IEnglishIqV2EvidenceProps): React.JSX.Element {
  const labels = {
    grammar: messages.grammar,
    listening: messages.listening,
    meaning: messages.meaning,
  };
  const icons = {
    grammar: TextCursorInput,
    listening: Ear,
    meaning: Languages,
  };
  return (
    <section className="mt-9">
      <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-[#ffb36b]">
        {messages.evidenceTitle}
      </h3>
      <div className="mt-4 flex flex-wrap gap-3">
        {evidence.map((entry) => {
          const Icon = icons[entry.skill];
          return (
            <div
              className="inline-flex min-h-11 items-center gap-2 rounded-full border border-[#f7edda]/15 bg-[#f7edda]/5 px-4"
              key={entry.skill}
            >
              <Icon aria-hidden="true" className="size-4 text-[#ff9b50]" />
              <span>{labels[entry.skill]}</span>
              <span className="text-[#f7edda]/45">{entry.answered}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
